import LoginPage from "../../components/Login/LoginPage";
import { LoginRedirect } from "../../domains/Redirects/LoginRedirect";

export const GENERAL_ROUTES = {
  Login: "/login",
};

export const GeneralPublicRoutes = [
  {
    path: GENERAL_ROUTES.Login,
    element: <LoginRedirect />,
  },
  {
    path: "*",
    element: <LoginPage />,
  },
];
